import $axios from "../../../api/accessories";
import { $api } from "../../../api/api";
import { getCookie } from "../../../api/utils/utils";

export class BasketProvider {
  static async getAllBasket() {
    const guestToken = getCookie("x-guest-token");
    const url = guestToken
      ? $api("basket", { guest_token: guestToken })
      : $api("basket");
    return await $axios.get(url);
  }
  static async postAddBasket(payload: {
    product_id: number;
    quantity: number;
  }) {
    const guestToken = getCookie("x-guest-token");
    const url = guestToken
      ? $api("basket", { guest_token: guestToken })
      : $api("basket");
    return await $axios.post(url, payload);
  }
  static async createOrder(payload: any) {
    return await $axios.post($api("create_order"), payload);
  }
  static async putBasket(payload: { product_id: number; quantity: number }) {
    const guestToken = getCookie("x-guest-token");
    const url = guestToken
      ? $api("basket", { guest_token: guestToken })
      : $api("basket");
    return await $axios.put(url, payload);
  }
  static async deleteBasket(id: number) {
    const guestToken = getCookie("x-guest-token");
    const url = guestToken
      ? $api("remove_basket", { id, guest_token: guestToken })
      : $api("remove_basket", { id });
    return await $axios.delete(url);
  }
  static async clearBasket() {
    const guestToken = getCookie("x-guest-token");
    const url = guestToken
      ? $api("basket", { guest_token: guestToken })
      : $api("basket");
    return await $axios.delete(url);
  }
  static async getTotalBasket() {
    const guestToken = getCookie("x-guest-token");
    const url = guestToken
      ? $api("total_basket", { guest_token: guestToken })
      : $api("total_basket");
    return await $axios.get(url);
  }
  static async getFilials() {
    return await $axios.get($api("get_filials"));
  }

  static async postQuickOrder(payload: {
    product_id: number;
    name: string;
    phone: string;
  }) {
    return await $axios.post($api("post_quick_order"), payload);
  }
}
